(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.clt').forEach(function (root) {
  var tabs = root.querySelectorAll('.clt__tab');
  var panels = root.querySelectorAll('.clt__panel');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var panel = root.querySelector('#' + tab.dataset.panel);
      if (panel) { panel.classList.add('is-active'); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
